<template>
  <v-row no-gutters justify="center" style="text-align: left">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="pa-5"
    >
      <!-- pass through scoped slots -->
      <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
        <slot :name="scopedSlotName" v-bind="slotData" />
      </template>

      <!-- pass through normal slots -->
      <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
        <slot :name="slotName" />
      </template>
      <v-card class="d-flex flex-column">
        <v-toolbar color="primary" class="shrink">
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $props.title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn text @click="dialog = false">{{ $t('Save') }}</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          top
          color="white"
        ></v-progress-linear>
        <v-row no-gutters class="pa-5 grow">
          <v-col cols="4" v-if="!$props.hideRegistryInfo">
            <v-list style="text-align: left">
              <v-subheader>{{ $t('Registry Info') }}</v-subheader>
              <registry-info-card :data="regInfo" :error="registryError"></registry-info-card>
            </v-list>
            <v-list style="text-align: left">
              <v-subheader>{{ $t('Certificate Info') }}</v-subheader>
              <v-btn @click="preview" :disabled="loading">
                {{ $t('Preview Digital Version') }}
              </v-btn>
            </v-list>
            <v-list style="text-align: left">
              <v-subheader>{{ $t('Administration') }}</v-subheader>
              <v-list-item>
                <v-checkbox disabled label="Mark as fulfilled"></v-checkbox>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col
            :cols="$props.hideRegistryInfo ? 12 : 8"
            class="grow d-flex flex-column flex-nowrap pl-5"
          >
            <v-list style="text-align: left">
              <v-subheader>{{ $t('Email Notification') }}</v-subheader>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field v-model="to" x-small hide-details :label="$t('To:')"></v-text-field>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="primary"
                    :disabled="loading || !isValidEmail(to)"
                    @click="sendEmailNotification($props.data)"
                  >
                    <v-icon left>mdi-email-fast-outline</v-icon>
                    {{ $t('Send Email') }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                <v-text-field
                  x-small
                  disabled
                  hide-details
                  :label="$t('Subject:')"
                  :value="subject"
                ></v-text-field>
              </v-list-item>
            </v-list>
            <div
              v-if="emailError"
              class="d-flex align-center justify-center mx-auto my-auto"
              dark
              min-height="293"
            >
              <v-card-text class="text-center">
                <v-icon size="64" class="mb-5" style="opacity: 0.7" color="error"
                  >mdi-email-remove-outline</v-icon
                >
                <h2 class="mb-5">{{ $t('COULD NOT LOAD EMAIL TEMPLATE') }}</h2>
                <h4>{{ $t('Please contact the developer!') }}</h4>
              </v-card-text>
            </div>
            <iframe v-else frameBorder="0" class="grow" :srcdoc="srdoc" width="100%"></iframe>
          </v-col>
        </v-row>
      </v-card>
      <div class="text-center">
        <v-snackbar
          :timeout="snackbar.timeout"
          v-model="snackbar.show"
          top
          :color="snackbar.color"
          elevation="24"
        >
          {{ snackbar.message }}
          <template v-slot:action="{ attrs }">
            <v-btn color="black" v-bind="attrs" @click="snackbar.show = false"> Close </v-btn>
          </template>
        </v-snackbar>
      </div>
    </v-dialog>
  </v-row>
</template>

<script>
  import registryInfoCard from './RegistryInfoCard'
  import { getRegistry } from '../services/registryService'
  import { previewEmail, sendEmail } from '../services/emailService'

  export default {
    props: ['title', 'data', 'store', 'hideRegistryInfo', 'template', 'isMizodiaStore'],
    data() {
      return {
        dialog: false,
        loading: false,
        to: this.$props.data.customer.email,
        subject: '',
        regInfo: [],
        srdoc: '',
        registryError: false,
        emailError: false,
        snackbar: {
          show: false,
          timeout: 2000,
          color: 'primary',
          message: '',
        },
      }
    },
    methods: {
      isValidEmail(str) {
        if (!str) return false
        /* eslint-disable */
        const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        const mailingList = str.split(',')
        let valid = true
        mailingList.forEach((mail) => {
          if (valid) valid = pattern.test(mail.trim())
        })
        return valid

        /* eslint-enable */
      },
      async sendEmailNotification(order) {
        this.loading = true
        try {
          await sendEmail(
            this.buildEmailRequestBody('send', order, this.$props.isMizodiaStore),
            this.$props.isMizodiaStore
          )
          this.showSnackbar('success', 'Email sent successfully!')
        } catch (error) {
          console.log(error)
          this.showSnackbar('error', 'Something went wrong!')
        } finally {
          this.loading = false
        }
      },
      preview: function () {
        this.$emit('preview', this.$props.data)
      },
      showSnackbar(type, message) {
        this.snackbar.color = type
        this.snackbar.message = message
        this.snackbar.show = true
      },
      buildEmailRequestBody(action, order, isMizodiaStore) {
        if (isMizodiaStore) {
          const countryCode = order.customer.countryCode?.toLowerCase()
          const lang = ['it', 'de'].includes(countryCode) ? countryCode : 'en'

          return {
            template: this.$props.template,
            locale: `${lang}_${this.$props.store}`,
            recipientEmail: this.to,
            data: {
              orderId: order.id,
              upgrade: order.upgrade,
              customerFirstName: order.customer.firstName,
              customerCountryCode: order.customer.countryCode,
              waitTime: '2w',
            },
          }
        }

        const orderIndex = 0

        return action === 'send'
          ? {
              orderNumber: order.orderNumber,
              customer: order.customer,
              orderId: order.id,
              storeId: this.$props.store,
              upgrade: order.upgrade,
              to: this.to,
            }
          : {
              regNum: order.stars[orderIndex],
              customer: {
                firstName: order.customer.firstName,
                email: order.customer.email,
                countryCode: order.customer.countryCode,
              },
              orderId: order.id,
              storeId: this.$props.store,
              color: order.colors[orderIndex],
              upgrade: order.upgrade,
            }
      },
    },
    watch: {
      dialog: {
        handler: async function (val) {
          if (val === false) return
          this.loading = true
          const order = this.$props.data

          try {
            const response = await previewEmail(
              this.buildEmailRequestBody('preview', order, this.$props.isMizodiaStore),
              this.$props.isMizodiaStore
            )
            console.log('response:', response)
            const data = response.data
            this.srdoc = data.content
            this.subject = data.subject
          } catch (error) {
            console.log(error)
            this.showSnackbar('error', 'Could not load email template!')
            this.emailError = true
          }

          if (this.$props.hideRegistryInfo) {
            this.loading = false
            return
          }

          try {
            this.regInfo = []
            for (let i = 0; i < order.stars?.length || 0; i++) {
              const { data } = await getRegistry(order.stars[i])
              this.regInfo.push(data)
            }
          } catch (error) {
            this.showSnackbar('error', 'Could not load registration details!')
            this.registryError = true
          } finally {
            this.loading = false
          }
        },
      },
    },
    components: { registryInfoCard },
  }
</script>
